import React from 'react';
import icon from '../../../../assets/dbs/db_Test.png';

const TestIcon = () => (
    <div>
        <img style = {{height: 25, paddingBottom:5, paddingRight: 5}} src={icon} alt="test"/>
    </div>
);
export default TestIcon;